import React, { useEffect, useState } from 'react';
import './index.css';
import styled from '@emotion/styled';
import { ReminderFolderProps, ReminderProps } from './types/ReminderListProps';
import { Radio } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import SearchInput from 'common/components/SearchInput';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as InfoIcon } from 'common/icons/info.svg';

const StyledSidebar = styled.div`
  // 5% opacity
  border: 1px solid ${props => props.theme.colors.gray};
  width: 230px;
  padding: 16px 4px;
  display:flex;
  flex-direction:column;
  border-radius: 16px;
`;
const SidebarScroller = styled.div`
  padding: 0 4px;
  display:flex;
  flex-direction:column;
  overflow-y: auto;
  overflow-x: hidden;
`;

const StyledNavLink = styled.button`
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  color: ${props => props.theme.colors.primaryTextColor};
  border-radius: 4px;
  &.active {
    // .15 opacity
    background-color: ${props => props.theme.colors.primaryColor + '26'};
  }
`;

const InfoButton = styled.button`
  display:flex;
  justify-content: center;
  align-items: center;
  height:24px;
  width:24px;
  cursor: pointer;
  & svg, & path {
    fill: ${props => props.theme.colors.gray};
    transition: fill .2s ease-in-out;
  }
  &:hover svg, &:hover path {
    fill: ${props => props.theme.colors.primaryColor};
  }
`;

const StyledNavLinkSubtext = styled.span`
  color: ${props => props.theme.colors.gray};
`;

const mockReminders: ReminderProps[] = [
  {
    id: '1',
    text: 'Записати відео про роботу з клієнтом',
    isDone: false,
  },
  {
    id: '2',
    text: 'Уточнити деталі замовлення',
    isDone: true,
  },
  {
    id: '3',
    text: 'Переписати текст на сайті',
    isDone: false,
    date: new Date('11-08-2023T12:00:00'),

  },
  {
    id: '4',
    text: 'Переписати текст на сайті',
    isDone: false,
    date: new Date('11-08-2023T12:00:00'),
    days: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
  },
];

const getRandomReminder = () => {
  const possibleDays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];
  const randomDaysArray = [];

  // 10% chance to have days
  // random amount of days from 1 to 7

  if (Math.random() > 0.9) {
    const randomDaysAmount = Math.floor(Math.random() * 7) + 1;
    for (let i = 0; i < randomDaysAmount; i++) {
      const randomDay = possibleDays[Math.floor(Math.random() * possibleDays.length)];
      if (!randomDaysArray.includes(randomDay)) {
        randomDaysArray.push(randomDay);
      }
    }
  }

  // sort days to be correct

  randomDaysArray.sort((a, b) => possibleDays.indexOf(a) - possibleDays.indexOf(b));

  const randomId = uuidv4();
  // text plus 4 characters of id
  const randomText = mockReminders[Math.floor(Math.random() * mockReminders.length)].text + ' ' + randomId.slice(0, 4);
  const randomIsDone = Math.random() > 0.5;
  // date with 25% chance
  const randomDate = new Date('11-08-2023');
  // set random day and month
  randomDate.setDate(Math.floor(Math.random() * 30));
  // set random time in date with 50% chance
  if (Math.random() > 0.5) {
    randomDate.setHours(Math.floor(Math.random() * 24));
    randomDate.setMinutes(Math.floor(Math.random() * 60));
  }
  console.log(randomDate);
  return {
    id: randomId,
    text: randomText,
    isDone: randomIsDone,
    date: Math.random() > 0.25 ? randomDate : undefined,
    days: randomDaysArray,
  };
};


// populate mock data


const ReminderEntry = ({ reminder, onChange }: { reminder: ReminderProps, onChange: (reminderId: string) => void }) => {
  // if reminder has date and no days, show "Термін до DD.MM HH:mm"
  // if reminder has days, show "Термін у [days] о HH:mm"
  // if reminder has all 7 days, show "Термін кожного дня о HH:mm"
  const getReminderDateText = () => {
    if (reminder.date) {
      if (reminder.days.length > 0) {
        if (reminder.days.length === 7) {
          return `Термін кожного дня о ${reminder.date.toLocaleTimeString().slice(0, -3)}}`;
        } else {
          return `Термін у ${reminder.days.join(', ')} о ${reminder.date.toLocaleTimeString().toString().slice(0, -3)}`;
        }
      } else {
        // if the date is tommorow write "Термін завтра", and if it has set time that is not 00:00, write "Термін завтра о HH:mm"
        const today = new Date();
        if (reminder.date.getDate() === today.getDate() + 1) {
          if (reminder.date.getHours() === 0 && reminder.date.getMinutes() === 0) {
            return 'Термін завтра';
          } else {
            return `Термін завтра о ${reminder.date.toLocaleTimeString().toString().slice(0, -3)}`;
          }
        }
        // Same for today
        if (reminder.date.getDate() === today.getDate()) {
          if (reminder.date.getHours() === 0 && reminder.date.getMinutes() === 0) {
            return 'Термін сьогодні';
          } else {
            return `Термін сьогодні о ${reminder.date.toLocaleTimeString().toString().slice(0, -3)}`;
          }
        }
        return `Термін до ${reminder.date.getDate()}.${reminder.date.getMonth() + 1} ${reminder.date.toLocaleTimeString().toString().slice(0, -3)}`;
      }
    }
    return '';
  };

  return (
    <div className='reminder-container'>
    <div className='reminder-entry'>
      <div className='reminder-entry-radio-wrapper'>
        <Radio size='small' checked={reminder.isDone} onClick={() => onChange(reminder.id)} />
      </div>
      <div className='reminder-entry-text-wrapper'>
        <span className='reminder-entry-text'>{reminder.text}</span>
        <StyledNavLinkSubtext className='reminder-entry-date'>{getReminderDateText()}</StyledNavLinkSubtext>
      </div>
    </div>
    <InfoButton>
      <InfoIcon className='svg-black svg-fill' />
    </InfoButton>
    </div>
  );
};



export default function RemindersPage() {
  const [reminders, setReminders] = useState<ReminderFolderProps[]>([]);
  useEffect(() => {
    const reminderMockData: ReminderFolderProps[] = [];
    for (let i = 0; i < 50; i++) {
      reminderMockData.push({
        id: i.toString(),
        title: `Нагадування ${i}`,
        reminders: [getRandomReminder(), getRandomReminder(), getRandomReminder()],
      });
    }
    setReminders(reminderMockData);    
  }
  , []);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchValue = searchParams.get('search') || '';
  const selectedFolder = searchParams.get('folder') || 'all';

  const totalReminders = reminders.flatMap(folder => folder.reminders).length;
  const completedReminders = reminders.flatMap(folder => folder.reminders.filter(reminder => reminder.isDone)).length;
  const completedInCurrentFolder = reminders.find(folder => folder.id === selectedFolder)?.reminders.filter(reminder => reminder.isDone).length || 0;

  const shownCompleted = (selectedFolder === 'all' || selectedFolder === 'completed') ? completedReminders : completedInCurrentFolder;


  const changeFolder = (folderId: string) => {
    searchParams.set('folder', folderId);
    setSearchParams(searchParams);
  };

  const ReminderNavigation = ({ to, children }: { to: string, children: React.ReactNode }) => {
    return (
      <StyledNavLink onClick={() => { changeFolder(to); }} className={to === selectedFolder ? 'active' : ''}>
        {children}
      </StyledNavLink>
    );
  };

  const onSearchChange = (value: string) => {
    if (value === '') {
      searchParams.delete('search');
    } else {
      searchParams.set('search', value);
    }
    setSearchParams(searchParams);
  };

  const changeReminder = (reminderId: string) => {
    // find reminder and change it, all reminders have unique ids
    const reminderFolderIndex = reminders.findIndex(folder => folder.reminders.find(reminder => reminder.id === reminderId));
    const reminderIndex = reminders[reminderFolderIndex].reminders.findIndex(reminder => reminder.id === reminderId);
    const newReminders = [...reminders];
    newReminders[reminderFolderIndex].reminders[reminderIndex].isDone = !newReminders[reminderFolderIndex].reminders[reminderIndex].isDone;
    setReminders(newReminders);
  };
  const shownReminders: ReminderProps[] = reminders.find(folder => folder.id === selectedFolder)?.reminders || [];

  const searchedReminders = shownReminders.filter(reminder => reminder.text.includes(searchValue));


  let folderTitle = '';
  if (selectedFolder === 'all') {
    folderTitle = 'Усі';
  } else if (selectedFolder === 'completed') {
    folderTitle = 'Виконані';
  } else {
    folderTitle = reminders.find(folder => folder.id === selectedFolder)?.title;
  }

  return (
    <div className='reminders-section'>
      <StyledSidebar>
        <SidebarScroller className='u-fancy-scrollbar'>
          <ReminderNavigation to='completed'>
            <span className='reminders-navigation-text'>Виконані</span>
            <StyledNavLinkSubtext className='reminders-navigation-text'>{completedReminders}</StyledNavLinkSubtext>
          </ReminderNavigation>
          <ReminderNavigation to='all'>
            <span className='reminders-navigation-text'>Усі</span>
            <StyledNavLinkSubtext className='reminders-navigation-text'>{totalReminders}</StyledNavLinkSubtext>
          </ReminderNavigation>
          {reminders.map((folder, index) => (
            <ReminderNavigation key={index} to={folder.id}>
              <span className='reminders-navigation-text'>{folder.title}</span>
              <StyledNavLinkSubtext className='reminders-navigation-text'>{folder.reminders.length}</StyledNavLinkSubtext>
            </ReminderNavigation>
          ))}
        </SidebarScroller>
      </StyledSidebar>
      <div className='reminders-content u-fancy-scrollbar'>
        <SearchInput style={{ flex: 1 }} wrapperStyle={{ width: '100%' }} value={searchValue} onChange={onSearchChange} />
        <div className='reminders-content-scroller u-fancy-scrollbar'>
          <div className='reminders-content-title-wrapper'>
            <span className='big-text'>{folderTitle}</span>
            <StyledNavLinkSubtext className='reminders-content-subtitle'>
              {`${shownCompleted} виконані`}
            </StyledNavLinkSubtext>
          </div>
          {
            /* If folder is all or completed add folder titles for each folder's reminders */
            <div className='reminders-content-folders'>
              {(selectedFolder === 'all' || selectedFolder === 'completed') ? reminders.map(folder => {
                if (!folder.reminders.find(reminder => reminder.text.includes(searchValue))) return null;
                // If out of all completed there is not a single that includes the search return null
                if (selectedFolder === 'completed') {
                  // find all reminders that are done and include the search value
                  const completedRemindersSearched = folder.reminders.filter(reminder => reminder.isDone && reminder.text.includes(searchValue));
                  if (completedRemindersSearched.length === 0) return null;
                }
                if (selectedFolder === 'completed' && !folder.reminders.find(reminder => reminder.isDone)) return null;
                return (
                  <div className='reminders-folder-wrapper' key={folder.id}>
                    <span className='reminders-folder-title'>{folder.title}</span>
                    <div className='reminders-list-wrapper'>
                      {folder.reminders.map(reminder => {
                        if (!reminder.text.includes(searchValue)) return null;
                        if (selectedFolder === 'completed' && !reminder.isDone) return null;
                        return (
                          <ReminderEntry key={reminder.id} reminder={reminder} onChange={changeReminder} />
                        );
                      })}
                    </div>
                  </div>
                );
              })
                :
                /* Else just show reminders */
                <div className='reminders-list-wrapper'>
                  {searchedReminders.map(reminder => (
                    <ReminderEntry key={reminder.id} reminder={reminder} onChange={changeReminder} />
                  ))}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  );
}